import React, { FC } from 'react';
import { Price as PriceType, Promo } from 'shared-types/Common';
import { Price } from '..';

type DiscountValueProps = {
  discountValue: Promo;
};

export const DiscountValue: FC<DiscountValueProps> = ({ discountValue }) => {
  const { value, type } = discountValue;

  const discountType = {
    percentage: <>-{value}%</>,
    price: (
      <>
        -
        <Price price={value as PriceType} />
      </>
    ),
  };
  return discountType[type] || null;
};
